import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { IDCARD_SECTIONS_ENUM } from './constants';
import { calculateComparisonCuts, getCatalogItemMetadata, getSectionsMetadata } from './utils';

export const useComparisonState = ({ firstSlotCatalogItem, secondSlotCatalogItem }) => {
  const [comparisonState, setComparisonState] = useState(
    getSectionsMetadata({ firstSlotCatalogItem, secondSlotCatalogItem })
  );

  const updateComparisonState = (sectionId, updatedMetadata) => {
    setComparisonState((current) => ({ ...current, [sectionId]: updatedMetadata }));
  };

  const onToggleSubMenuItem = (sectionId, isOpen) => {
    const isCollapsed = !isOpen;
    const currentMetadata = comparisonState[sectionId];
    const updatedSectionMetadata = getCatalogItemMetadata({
      ...currentMetadata,
      isCollapsed,
    });

    updateComparisonState(sectionId, updatedSectionMetadata);
  };

  const { ViewsAndLayouts, LocationOnFPSO } = IDCARD_SECTIONS_ENUM;
  const viewsAndLayoutsMetadata = comparisonState[ViewsAndLayouts];
  const locationOnFPSOMetadata = comparisonState[LocationOnFPSO];

  useEffect(() => {
    setComparisonState(getSectionsMetadata({ firstSlotCatalogItem, secondSlotCatalogItem }));
  }, [firstSlotCatalogItem, secondSlotCatalogItem]);

  useEffect(() => {
    const areThereComparisonCuts = !isEmpty(viewsAndLayoutsMetadata.comparisonCuts);
    const shouldCalculateComparisonCuts = !viewsAndLayoutsMetadata.isCollapsed;

    if (!shouldCalculateComparisonCuts) {
      if (!areThereComparisonCuts) {
        return;
      }

      updateComparisonState(ViewsAndLayouts, { ...viewsAndLayoutsMetadata, comparisonCuts: [] });
      return;
    }

    const comparisonCuts = calculateComparisonCuts({
      sectionId: ViewsAndLayouts,
      firstSlotCatalogItem,
      secondSlotCatalogItem,
    });

    updateComparisonState(ViewsAndLayouts, { ...viewsAndLayoutsMetadata, comparisonCuts });
  }, [viewsAndLayoutsMetadata.isCollapsed]);

  useEffect(() => {
    const areThereComparisonCuts = !isEmpty(locationOnFPSOMetadata.comparisonCuts);
    const shouldCalculateComparisonCuts = !locationOnFPSOMetadata.isCollapsed;

    if (!shouldCalculateComparisonCuts) {
      if (!areThereComparisonCuts) {
        return;
      }

      updateComparisonState(LocationOnFPSO, { ...locationOnFPSOMetadata, comparisonCuts: [] });
      return;
    }

    const comparisonCuts = calculateComparisonCuts({
      sectionId: LocationOnFPSO,
      firstSlotCatalogItem,
      secondSlotCatalogItem,
    });

    updateComparisonState(LocationOnFPSO, { ...locationOnFPSOMetadata, comparisonCuts });
  }, [locationOnFPSOMetadata.isCollapsed]);

  return { comparisonState, onToggleSubMenuItem };
};
